const DEFAULT_SERVICE_BASE_URL = "https://svc11.accelasearch.io";

function withoutTrailingSlash(value) {
  return String(value || "").trim().replace(/\/+$/, "");
}

function serviceUrlFromApiUrl(apiBaseUrl) {
  return withoutTrailingSlash(apiBaseUrl).replace(/\/API$/i, "");
}

export function resolveEnvironment({
  env = {},
  isDevelopment = false,
  browserOrigin = "",
} = {}) {
  const configuredApiBaseUrl = withoutTrailingSlash(
    env.VITE_API_BASE_URL,
  );
  const configuredServiceBaseUrl = withoutTrailingSlash(
    env.VITE_SERVICE_BASE_URL ||
      env.VITE_BASEURL,
  );
  const serviceBaseUrl = configuredServiceBaseUrl ||
    serviceUrlFromApiUrl(configuredApiBaseUrl) ||
    DEFAULT_SERVICE_BASE_URL;
  const directApiBaseUrl = configuredApiBaseUrl || `${serviceBaseUrl}/API`;
  const useDevelopmentProxy = isDevelopment && env.VITE_USE_API_PROXY !== "false";

  return {
    apiBaseUrl: useDevelopmentProxy ? "/API" : directApiBaseUrl,
    serviceBaseUrl: useDevelopmentProxy
      ? withoutTrailingSlash(browserOrigin)
      : serviceBaseUrl,
    directServiceBaseUrl: serviceBaseUrl,
    directApiBaseUrl,
    useDevelopmentProxy,
  };
}

export const environment = resolveEnvironment({
  env: import.meta.env,
  isDevelopment: import.meta.env.DEV,
  browserOrigin: typeof window !== "undefined" ? window.location.origin : "",
});

export function serviceEndpoint(pathname = "") {
  const path = String(pathname).startsWith("/") ? pathname : `/${pathname}`;
  return `${environment.serviceBaseUrl}${path}`;
}

/** Utils.isLocalhost() || Utils.isDev(): in locale e sui due host di dev il reCAPTCHA della registrazione non si mostra. */
export function isLocalDevelopmentHost(hostname = window.location.hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "as-bo.dev70.ittweb.net" || hostname === "as-bo.dev1.accelasearch.net";
}
